import React from 'react';
import NotificationPermissionModal from './NotificationPermissionModal';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { useFCMToken } from '../hooks/useFCMToken';

const NotificationProvider = ({ userId, children }) => {
  const { 
    showPermissionModal, 
    setShowPermissionModal, 
    handlePermissionGranted 
  } = usePushNotifications(userId);

  // Initialize FCM alongside existing VAPID-based push notifications
  const { 
    fcmToken, 
    fcmSupported, 
    error: fcmError 
  } = useFCMToken(userId);

  React.useEffect(() => {
    if (fcmError) {
    }
    if (fcmSupported && fcmToken) {
    }
  }, [fcmToken, fcmSupported, fcmError]);

  const handleModalClose = () => {
    setShowPermissionModal(false);
  };

  return (
    <>
      {children}
      {/* Global Notification Permission Modal */}
      <NotificationPermissionModal
        isOpen={showPermissionModal}
        onClose={handleModalClose}
        onAllow={handlePermissionGranted}
      />
    </>
  );
};

export default NotificationProvider;
